import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  pagination: {
    marginTop: 24
  },
  card: {
    '& .ant-card-body': {
      padding: 0
    }
  }
}))
